var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal custom",
        attrs: { id: "teamMemberRestrictionPopup", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog request-modal" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.loadLogOut()
                    },
                  },
                },
                [_vm._v("×")]
              ),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn emergo-blue-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.loadLogOut()
                    },
                  },
                },
                [_vm._v("Okay")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-confirm" }, [
      _c("div", [
        _c("img", {
          staticClass: "check_img",
          attrs: { src: "/static/images/icons/expiry.svg", alt: "expiry-icon" },
        }),
        _c("h3", { staticClass: "confirm_title" }, [
          _vm._v("Your account has been blocked."),
        ]),
      ]),
      _c("div", [_vm._v("Please contact your Account Owner.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }